import moment from "moment";

const formatDateTrackingHistoryV2 = (
  date: any,
  timezone: any
) => {
  const formattedDate = new Date(date);

  let utcOffset = "0";
  if (timezone) {
    utcOffset = timezone.replace("GMT+", "+0").replace(":", "");
  }
  const newDate = moment(formattedDate)
    .utcOffset(utcOffset)
    .format("YYYY-MM-DD");
  return newDate;
};
export default formatDateTrackingHistoryV2;